module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Blockquote--Body-"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("“. . . In the fall one walks in the orchards and the ground is hard with frost underfoot. . . . On the trees are only a few gnarled apples that the pickers have rejected. . . . One nibbles at them and they are delicious. Into a little round place at the side of the apple has been gathered all of its sweetness. One runs from tree to tree over the frosted ground picking the gnarled, twisted apples and filling his pockets with them. Only the few know the sweetness of the twisted apples.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body- ParaOverride-3"
  }, [_c('span', {
    staticClass: "SmallCaps CharOverride-4"
  }, [_vm._v("SHERWOOD ANDERSON")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_c('br'), _vm._v("in Winesburg, Ohio")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28708b60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Baby_F_epub19.vue
// module id = 69
// module chunks = 0